import { useState } from "react";
import { Routes, Route, Link, useLocation, useNavigate } from "react-router-dom";
import ContractsPage from "./pages/ContractsPage";
import ContractDetail from "./pages/ContractDetail";
import TimesheetsPage from "./pages/TimesheetsPage";
import PaymentsPage from "./pages/PaymentsPage";
import InvoicesPage from "./pages/InvoicesPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ProfilePage from "./pages/ProfilePage";
import AttendancePage from "./pages/AttendancePage";
import CheckInWidget from "./components/CheckInWidget";
import ProtectedRoute from "./components/ProtectedRoute";
import { getSession, clearSession } from "./service/auth";
import "./styles/App.css";

export default function App() {
  const location = useLocation();
  const navigate = useNavigate();
  const session = getSession();
  const isLoggedIn = !!(session && session.email);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const getActiveClass = (path) =>
    location.pathname.startsWith(path) ? "navbar__tab--active" : "";

  const handleLogout = () => {
    clearSession();
    window.location.href = "/login";
  };

  return (
    <div className="app">
      {/* ── TOP HEADER ── */}
      <div className="top-content">
        <img src="/Favicon.png" alt="Top Logo" />
        {isLoggedIn && session && (
          <div className="top-content__info">
            <div className="top-content__title">{session.name || ""}</div>
            <div className="top-content__email">{session.email || ""}</div>
          </div>
        )}
        {/* Check-in / Check-out widget sits at the right of the header */}
        {isLoggedIn && (
          <div className="top-content__checkin">
            <CheckInWidget onNavigateToAttendance={() => navigate("/attendance")} />
          </div>
        )}
      </div>

      {/* ── NAVBAR ── */}
      {isLoggedIn && (
        <nav className={`navbar ${isMenuOpen ? "navbar--open" : ""}`}>
          {/* Mobile brand row */}
          <div className="navbar__mobile-brand">
            <img src="/Favicon.png" alt="Top Logo" />
            {session && (
              <div className="navbar__mobile-brand-info">
                <div className="navbar__mobile-brand-title">{session.name || ""}</div>
                <div className="navbar__mobile-brand-email">{session.email || ""}</div>
              </div>
            )}
          </div>

          {/* Hamburger */}
          <div
            className="navbar__mobile-toggle"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <div className={`hamburger ${isMenuOpen ? "hamburger--open" : ""}`}>
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          {/* Nav links */}
          <div className={`navbar__content ${isMenuOpen ? "navbar__content--open" : ""}`}>
            <div className="navbar__tabs">
              <Link
                to="/contracts"
                className={`navbar__tab ${getActiveClass("/contracts")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Contracts
              </Link>
              <Link
                to="/timesheets"
                className={`navbar__tab ${getActiveClass("/timesheets")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Timesheets
              </Link>
              <Link
                to="/payments"
                className={`navbar__tab ${getActiveClass("/payments")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Payments
              </Link>
              <Link
                to="/invoices"
                className={`navbar__tab ${getActiveClass("/invoices")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Invoices
              </Link>
              <Link
                to="/attendance"
                className={`navbar__tab ${getActiveClass("/attendance")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Attendance
              </Link>
            </div>

            <div className="navbar__user">
              <Link
                to="/profile"
                className={`navbar__tab ${getActiveClass("/profile")}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Profile
              </Link>
              <button
                onClick={() => { handleLogout(); setIsMenuOpen(false); }}
                className="navbar__tab logout-btn"
                style={{ background: "none", border: "none", cursor: "pointer", opacity: 0.7 }}
              >
                Logout
              </button>
            </div>
          </div>
        </nav>
      )}

      {/* ── ROUTES ── */}
      <main className="main">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<ProtectedRoute><ContractsPage /></ProtectedRoute>} />
          <Route path="/contracts" element={<ProtectedRoute><ContractsPage /></ProtectedRoute>} />
          <Route path="/contracts/:id" element={<ProtectedRoute><ContractDetail /></ProtectedRoute>} />
          <Route path="/timesheets" element={<ProtectedRoute><TimesheetsPage /></ProtectedRoute>} />
          <Route path="/payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
          <Route path="/invoices" element={<ProtectedRoute><InvoicesPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/attendance" element={<ProtectedRoute><AttendancePage /></ProtectedRoute>} />
        </Routes>
      </main>
    </div>
  );
}
